import { lazy } from "react";
import { Navigate } from "react-router-dom";

const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
// const Login = lazy(() => import("../views/Login/Login.js")); // Lazy load your Login component
const Dashboard1 = lazy(() => import("../views/dashboards/Dashboard1.js"));
const FundInvestment = lazy(() =>
  import("../views/FundInvestment/FundInvestment.js")
);
const CorporateInvestment = lazy(() =>
  import("../views/CorporateInvestment/CorporateInvestment.js")
);
const CompetitorList = lazy(() =>
  import("../views/CompetitorList/CompetitorList.js")
);
const CompetitorDashboard = lazy(() =>
  import("../views/CompetitorDashboard/CompetitorDashboard.js")
);

const InvestmentMonitor = lazy(() =>
  import("../views/InvestmentMonitor/InvestmentMonitor.js")
);

const HG = lazy(() => import("../views/OtherInvestment/HG.js"));

const CPInvestment = lazy(() =>
  import("../views/CPInvestment/CPInvestment.js")
);

// Competitor details
const AbInBev = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/abinbev.js")
);
const ADM = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/adm.js")
);
const Alibaba = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/alibaba.js")
);
const Amazon = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/amazon.js")
);
const Cargill = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/cargill.js")
);
const Carrefour = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/carrefour.js")
);
const Cocacola = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/cocacola.js")
);
const Cofco = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/cofco.js")
);
const Cpall = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/cpall.js")
);
const Danone = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/danone.js")
);
const Hemasupermarket = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/hemasupermarket.js")
);
const JBS = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/jbs.js")
);
const Kraftheinz = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/kraftheinz.js")
);
const Nestle = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/nestle.js")
);
const PandG = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/pandg.js")
);
const Pepsi = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/pepsi.js")
);
const Rtmart = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/rtmart.js")
);
const Starbucks = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/starbucks.js")
);
const Tesco = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/tesco.js")
);
const Tysonfoods = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/tysonfoods.js")
);
const Unilever = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/unilever.js")
);
const Walmart = lazy(() =>
  import("../views/CompetitorList/CompetitorDetail/walmart.js")
);

const ThemeRoutes = [
  // {
  //   path: "/",
  //   element: <Navigate to="/login" />, // Redirect to login first
  // },
  // {
  //   path: "/login",
  //   element: <Login />, // Login page route
  // },
  {
    path: "/",
    element: <FullLayout />,
    children: [
      { path: "dashboards/dashboard1", element: <Dashboard1 /> },
      { path: "/fund-investment", element: <FundInvestment /> },
      { path: "/corporate-investment", element: <CorporateInvestment /> },
      { path: "/competitor-list", element: <CompetitorList /> },
      { path: "/competitor-dashboard", element: <CompetitorDashboard /> },
      { path: "/other-investment/hg", element: <HG /> },
      { path: "/cp-investment", element: <CPInvestment /> },
      { path: "/investment-monitor", element: <InvestmentMonitor /> },

      // Competitor detail routes
      { path: "/competitor-details/abinbev", element: <AbInBev /> },
      { path: "/competitor-details/adm", element: <ADM /> },
      { path: "/competitor-details/alibaba", element: <Alibaba /> },
      { path: "/competitor-details/amazon", element: <Amazon /> },
      { path: "/competitor-details/cargill", element: <Cargill /> },
      { path: "/competitor-details/carrefour", element: <Carrefour /> },
      { path: "/competitor-details/coca-cola", element: <Cocacola /> },
      { path: "/competitor-details/cofco", element: <Cofco /> },
      { path: "/competitor-details/cp-all", element: <Cpall /> },
      { path: "/competitor-details/danone", element: <Danone /> },
      {
        path: "/competitor-details/hema-supermarket",
        element: <Hemasupermarket />,
      },
      { path: "/competitor-details/jbs", element: <JBS /> },
      { path: "/competitor-details/kraft-heinz", element: <Kraftheinz /> },
      { path: "/competitor-details/nestle", element: <Nestle /> },
      { path: "/competitor-details/pg", element: <PandG /> },
      { path: "/competitor-details/pepsi", element: <Pepsi /> },
      { path: "/competitor-details/rt-mart", element: <Rtmart /> },
      { path: "/competitor-details/starbucks", element: <Starbucks /> },
      { path: "/competitor-details/tesco", element: <Tesco /> },
      { path: "/competitor-details/tyson-foods", element: <Tysonfoods /> },
      { path: "/competitor-details/unilever", element: <Unilever /> },
      { path: "/competitor-details/walmart", element: <Walmart /> },

      // { path: "/login", element: <Login /> },
    ],
  },
];

export default ThemeRoutes;
